import { Checkbox } from '@components/Checkbox/Checkbox';
import { BaseSelection } from '@stores/MomentSelection/BaseSelection';
import { observer } from 'mobx-react';

type SelectionCheckboxProps = {
  selection: BaseSelection<any>;
  itemId: string;
  theme?: 'default' | 'monochrome';
  className?: string;
  toggle?: (itemId: string) => void;
};

export const SelectionCheckbox = observer(function SelectionCheckbox({
  selection,
  itemId,
  theme = 'default',
  className,
  toggle,
}: SelectionCheckboxProps) {
  const isSelected = selection.isSelected(itemId);

  const handleChange = () => {
    if (toggle) {
      toggle(itemId);
    } else {
      selection.toggleSelection(itemId);
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Checkbox
      checked={isSelected}
      onClick={handleClick}
      onChange={handleChange}
      theme={theme}
      className={className}
    />
  );
});
